import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Box, Typography } from '@mui/material'

import { PageDisplayer, FoldingPanel } from '../../../../ui'
import { useIPContext, IPForm, IPEventsTable } from '../../../../features/ip'

export const IPDetailPage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { ipId } = useParams()
  const { formatMessage } = useIntl()
  const { detailLoading, detailError, getIP } = useIPContext()

  useEffect(() => {
    getIP(ipId)
  }, [ipId]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleGoBack = () => {
    const prevSearch = location.state?.prevSearch || ''
    navigate(`/ip${prevSearch}`)
  }

  return (
    <PageDisplayer
      maxWidth="md"
      loading={detailLoading}
      handleGoBack={handleGoBack}
      textGoBack={formatMessage({ id: 'pages.ip.detail.goBack' })}
    >
      {detailError ? (
        formatMessage({ id: 'pages.ip.detail.error' })
      ) : (
        <>
          <Box mb={2}>
            <Typography variant="h4" color="textSecondary">
              {formatMessage({ id: 'pages.ip.detail.title' })}
            </Typography>
          </Box>
          <Box mb={2}>
            <IPForm />
          </Box>
          <FoldingPanel
            isExpanded={true}
            title={formatMessage({ id: 'pages.ip.detail.events.title' })}
          >
            <IPEventsTable />
          </FoldingPanel>
        </>
      )}
    </PageDisplayer>
  )
}
